const _Widgets = {};

export function registerWidget(options) {
  _Widgets[options.name] = options;
}
export function getWidget(name) {
  return _Widgets[name];
}
